import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

if (GA_ID && typeof window !== "undefined" && !window.gtag) {
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
}

export const AnalyticsTracker = () => {
  const location = useLocation();
  const lastSent = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastSent.current === path) return;
    lastSent.current = path;

    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.origin + path,
      });
    }

    if (path.startsWith("/analytics")) return;
    let sid = localStorage.getItem("merakee_sid");
    if (!sid) {
      sid = `v-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      localStorage.setItem("merakee_sid", sid);
    }
    api
      .post("/analytics/track", {
        session_id: sid,
        path,
        referrer: document.referrer || "",
      })
      .catch(() => {});
  }, [location]);

  return null;
};
